import React, { Component } from 'react';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Burger from './Burger/Burger';
import Controls from './Controls/Controls';
import Summary from './Summary/Summary';
import {connect} from 'react-redux'
import {addIngredient,removeIngredient,updatePrice} from '../../redux/ActionCreaters';


const mapStateToProps=state=>{
    return{
        ingredient:state.ingredient,
        totalPrice:state.totalPrice,
        purchase:state.purchase,
    }
}

const mapDispatchToProps=()=>dispatch=>{
    return{
        addIngredient:(type)=>dispatch(addIngredient(type)),
        removeIngredient:(type)=>dispatch(removeIngredient(type)),
        updatePrice:()=>dispatch(updatePrice())
    }
}
class BurgerBuilder extends Component{
    state={
        isModalOpen:false
    }

    addIngredientHandler=type=>{
        this.props.addIngredient(type);
        this.props.updatePrice();
    }
    removeIngredientHandler=type=>{
        this.props.removeIngredient(type);
        this.props.updatePrice();
    }

    ModalToggle=()=>{
        this.setState({
            isModalOpen:!this.state.isModalOpen
        })
    }

    checkoutHandle=()=>{
        this.props.history.push('/checkout');
    }
    render(){
        return(
            <div>
                <div>
                    <Burger ingredient={this.props.ingredient} />
                    <Controls 
                    ingredientAdd={this.addIngredientHandler}
                    ingredientRemove={this.removeIngredientHandler}
                    price={this.props.totalPrice}
                    purchase={this.props.purchase}
                    order={this.ModalToggle}
                    />
                </div>
                <Modal isOpen={this.state.isModalOpen}>
                    <ModalHeader>Order Summary</ModalHeader>
                    <ModalBody>
                        Total Price : <strong>{this.props.totalPrice } BDT</strong>
                        <Summary ingredient={this.props.ingredient} />
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.checkoutHandle} className="heading btn">Continue to checkout</Button>
                        <Button onClick={this.ModalToggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
            
        )
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(BurgerBuilder);